import React from 'react';
import { VenueInput } from './../../../globalTypes';
const PencilIcon = require('./pencil.svg');

interface GenericSectionProps {
  id: string;
  title: string;
  options: any;
  component: any;

  editing: boolean;
  loading: boolean;
  onSubmit(data: VenueInput);
  onCancelEditing();
  onStartEditing(id: string);
}

export class GenericSection extends React.Component<GenericSectionProps> {
  handleEdit = () => {
    this.props.onStartEditing(this.props.id);
  };

  handleCancel = () => {
    this.props.onCancelEditing();
  };

  handleSave = (submitData) => {
    this.props.onSubmit(submitData);
  };

  render() {
    const SectionComponent = this.props.component;
    let content;
    if (!this.props.loading) {
      content = (
        <SectionComponent
          onSubmit={this.handleSave}
          editing={this.props.editing}
          {...this.props.options}
          handleCancel={this.handleCancel}
        />
      );
    } else {
      content = 'Loading';
    }

    let editIcon: any = null;
    let editText: any = null;
    if (!this.props.editing) {
      editIcon = (
        <img
          src={PencilIcon}
          className='d-none d-md-inline-block divided-header-editing-icon'
          onClick={this.handleEdit}
        />
      );
      editText = (
        <div onClick={this.handleEdit} className='manage-venue-edit-text'>
          Edit
        </div>
      );
    } else {
      editText = (
        <div onClick={this.handleCancel} className='manage-venue-cancel-text'>
          Cancel
        </div>
      );
    }

    return (
      <section className='manage-venue-section' id={this.props.id}>
        <h4 className='divided-header'>
          {this.props.title}
          {editIcon}
          {editText}
        </h4>
        {content}
      </section>
    );
  }
}
